import { useOrderFlowContext } from '@euler/app/flows/order/OrderFlowContext';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useBehaviorSubject } from '@euler/utils/hooks';
import { memo, useCallback, useState } from 'react';
import { TextInput, View } from 'react-native';

export const HeaderTitle = memo(() => {
  const { rpx } = useResponsiveContext();
  const { serviceSubjectQuery$ } = useOrderFlowContext();
  const [query, setQuery] = useBehaviorSubject(serviceSubjectQuery$);
  const [isFocused, setIsFocused] = useState(false);
  const onFocus = useCallback(() => {
    setIsFocused(true);
  }, []);
  const onBlur = useCallback(() => {
    setIsFocused(false);
  }, []);
  return (
    <View
      css={`
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background-color: #f4f4f4;
        border-radius: ${rpx(80)}px;
      `}
    >
      <Icon
        name="search"
        color={isFocused ? '#333' : '#ABABAB'}
        size={rpx(16)}
        css={`
          margin-left: ${rpx(10)}px;
          margin-right: ${rpx(6)}px;
        `}
      />
      <TextInput
        value={query}
        onChangeText={setQuery}
        placeholder="搜索项目"
        onFocus={onFocus}
        onBlur={onBlur}
        clearButtonMode="always"
        css={`
          flex: 1;
          color: ${isFocused ? '#333' : '#ABABAB'};
          height: ${rpx(32)}px;
        `}
      />
    </View>
  );
});
